import httpClient from "../../services/http";

export const getPaymentsPDFService = (ref) =>
  httpClient.get(`/order-service/pay/get/pdf/${ref}`);

export const sendPaymentInvoiceEmailService = (ref) =>
  httpClient.get(`/order-service/pay/mail/pdf/${ref}`);
